<script>
import ModuleTitle from '../common/ModuleTitle.vue'

import { getShadowColor, getPageThemeColor, getFileTypeLogo } from '@/utils/modules/getStyles'
import { richTextImgHandler, getFileType } from '@/utils/common'
import { hiddenPhone } from '@/utils/filters'

export default {
  name: 'Comp59',
  components: { ModuleTitle },
  props: {
    moduleOption: {
      type: Object,
      default: () => {}
    }
  },
  data() {
    return {
      path: this.$route.path,
      admini: localStorage.getItem('admini')
    }
  },
  methods: {
    getShadowColor, getPageThemeColor, getFileTypeLogo,
    richTextImgHandler, getFileType,
    hiddenPhone,
    onModuleItem(v) {
      this.$emit('onModuleItem', v)
    }
  }
}
</script>

<template>
  <div class="modules-id-59">
    <module-title :title="moduleOption.title" margin-bottom="24" />
    <div class="comp-transverse-3 modules-id-59-content pointer">
      <div
        v-for="(v, i) in moduleOption.list.slice(0, 3)"
        :key="`modules-58-${i}`"
        :style="{boxShadow: `0 3px 10px 0 ${getShadowColor(path)}`, borderColor: `${getPageThemeColor(path)}`}"
        class="item"
        @click="onModuleItem(v)"
      >
        <el-image v-if="v.typeid == 3" :src="getFileTypeLogo(v.typename, 'small')" class="item-logo" />
        <div class="item-content">
          <p class="h-line-1 item-headline">{{ v.headline || '' }}</p>
          <p class="h-line-1 item-memo" :class="{'item-memo-file': v.typeid == 3}">
            {{ v.typeid == 3 ? `文件格式: ${getFileType(v.typename)}` : v.memo | filtersRichtext }}
          </p>
        </div>
        <div class="item-retanc" :style="{backgroundColor: `${getPageThemeColor(path)}`}"></div>
      </div>
    </div>
  </div>
</template>

<style lang="scss" scoped>
.modules-id-59-content {
  height: 100%;
  display: flex;
  flex-wrap: wrap;
  align-items: flex-start;
  row-gap: 20px;
}
.item {
  width: 450px;
  height: 90px;
  background-color: #fff;
  border: 1px solid;
  padding: 0 30px;
  box-sizing: border-box;
  box-shadow: 0px 4px 15px 0px rgba(23,23,23,0.1);
  border-radius: 5px;
  display: flex;
  align-items: center;
  position: relative;
  .item-logo {
    width: 45px;
    height: 45px;
    margin-right: 15px;
  }
  .item-headline, .item-memo {
    // width: 390px;
    color: #000;
  }
  .item-headline {
    font-size: 17px;
    font-weight: bold;
  }
  .item-memo {
    font-size: 14px;
    margin-top: 10px;
  }
  .item-memo-file {
    color: #999;
  }
  .item-retanc {
    position: absolute;
    left: 0;
    top: 20px;
    width: 6px;
    height: 50px;
    background: #69B5C1;
    border-radius: 0px 5px 5px 0px;
  }
}
</style>
